/* Consumer hook for shared feed items context. */

import { useContext } from "react";
import { FeedItemsContext } from "@/contexts/feedItemsContextValue";

export function useFeedItems() {
  const context = useContext(FeedItemsContext);

  if (!context) {
    throw new Error("useFeedItems must be used within a FeedItemsProvider");
  }

  return context;
}
